<template>
  <div class="carousel-top">
    <el-carousel
      :height="carousel_config.height"
      :direction="carousel_config.direction"
      :autoplay="carousel_config.autoplay"
      :interval="carousel_config.interval"
      :arrow="carousel_config.arrow"
    >
      <template v-if="carousel && carousel.length > 0">
        <el-carousel-item
          v-for="(item, index) in carousel"
          :key="index"
          v-carousel-count="item.id"
          interface-key="id"
        >
          <a
            class="el-carousel-link"
            v-if="item.url"
            :href="item.url"
            target="_blank"
          ></a>
          <el-image
            style="width: 100%; height: 100%"
            :src="item.img"
            fit="cover"
          ></el-image>
        </el-carousel-item>
      </template>
      <template v-else>
        <el-carousel-item v-for="item in 1" :key="item">
          <h3 class="medium">Banner{{ item }}</h3>
        </el-carousel-item>
      </template>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "carousel-top",
  props: {
    config: { type: Object },
    carousel: { type: Array },
  },
  computed: {
    carousel_config() {
      const { default_config, config } = this;

      return Object.assign({}, default_config, config);
    },
  },
  data() {
    return {
      default_config: {
        direction: "vertical",
        interval: 5000,
        autoplay: true,
        height: "200px",
        arrow: "hover",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.carousel-top {
  .el-carousel__item h3 {
    color: #fff;
    font-size: 50px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
    text-align: center;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #0080ff;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #41a0ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel/CarouselTop.vue